module.exports = __webpack_public_path__ + "img/百龄.bddf4cf.png";